import gql from 'graphql-tag';

export const GetMedicalTestResultList = gql`
  query GetMedicalTestResultList($startDate: Date!, $endDate: Date!) {
    getMedicalTestResultList(startDate: $startDate, endDate: $endDate) {
      total
      errors {
        errorCode
        errorDescription
        errors
        requestId
      }
      results {
        dfdEventId
        category
        source
        name
        testDate
        eventId
        isRead
        presentedForm {
          featureType
          contentType
          url
        }
        providerNames
        encounterId
        componentEventIds
      }
    }
  }
`;
